import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const techniciansService = {
    async list(query = {}) {
        const { data } = await api.get("/technicians", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/technicians/${id}`);
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/technicians", payload);
        return data;
    },
    async update(id, payload) {
        const { data } = await api.patch(`/technicians/${id}`, payload);
        return data;
    },
    async remove(id) {
        await api.delete(`/technicians/${id}`);
    },
    async specialties() {
        const { data } = await api.get("/technicians/specialties");
        return data;
    },
};
